import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { authService } from '../services/authService';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'en', nativeName: 'English' },
    { code: 'ar', nativeName: 'العربية' },
    { code: 'fr', nativeName: 'Français' }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    // Sync backend preference (fire-and-forget)
    authService.updateLanguage(lng);
    // Update user object in localStorage so AuthInitializer step 5 reads the
    // correct language on the next page reload and doesn't revert the selection
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        user.preferredLanguage = lng;
        localStorage.setItem('user', JSON.stringify(user));
      }
    } catch {
      // ignore localStorage errors
    }
  };

  return (
    <div className="relative inline-block text-left">
      <div className="flex items-center gap-2">
        <Globe className="w-5 h-5 text-gray-600" />
        <select
          value={i18n.language}
          onChange={(e) => changeLanguage(e.target.value)}
          className="block w-full px-3 py-2 text-base border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 bg-white"
          aria-label={t('common.selectLanguage')}
        >
          {languages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.nativeName}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
